<div class="category-groups-wrap">
  <span class="btn btn-slim btn-shadow-primary group-item"
        [class.active]="!activeGroupId"
        [translate]="'common.all'"
        (click)="$event.preventDefault(); selectGroup(null);">
    All
  </span>

  <span *ngFor="let group of linkGroups"
        class="btn btn-slim btn-shadow-primary group-item"
        [class.active]="group.id === activeGroupId"
        (click)="$event.preventDefault(); selectGroup(group)">
    {{ group.name }}
  </span>

  <div ngbDropdown #dropdown="ngbDropdown"
       *ngIf="dropdownGroups && dropdownGroups.length"
       (click)="$event.stopPropagation()">
    <button class="btn btn-slim btn-shadow-primary group-dropdown-item"
            ngbDropdownToggle
            [class.active]="selectedDropdownGroup">
      {{ selectedDropdownGroup ? selectedDropdownGroup.name : ('common.showMore' | translate) }}
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
      <ng-container *ngFor="let group of dropdownGroups">
        <span *ngIf="group.id !== selectedDropdownGroup?.id"
              class="dropdown-item font-md"
              (click)="$event.preventDefault(); dropdownSelectCategory(group); dropdown.close()">
          {{ group.name }}
        </span>
      </ng-container>
    </div>
  </div>
</div>
